<template>
	<div class="date-mini">
		<div class="date-container">
			<div class="date-lg">
				{{ currentDate }}
			</div>
			<div class="dates-small">
				<div class="date-utc">
					{{ dateUtc }}
				</div>
				<div class="date-stardate">
					{{ starDate }}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	let refreshInterval = null;
    
	export default {
		name: 'MiniDate',
		data() {
			return {
				currentDate: '',
				dateUtc: '',
				starDate: ''
			}
		},
		
		mounted() {
			console.log("Date mini module initiated");
			this.updateDate();
			refreshInterval = setInterval(this.updateDate, 1000);
		},

		destroyed() {
			console.log("Stopping Date mini module");
			clearInterval(refreshInterval);
		},

		methods: {
			updateDate() {
				let thisDate = moment();
				this.currentDate = thisDate.format("dddd, MMMM D");
				this.dateUtc = thisDate.utc().format("M/D") + " UTC";
				this.starDate = "Stardate " + this.getStardate();
			},
			getStardate() {
				let today = new Date();
				let stardateOrigin = new Date("July 15, 1987 00:00:00");
				let stardateToday = today.getTime() - stardateOrigin.getTime();
				stardateToday = stardateToday / (1000 * 60 * 60 * 24 * 0.036525);
				stardateToday = Math.floor(stardateToday + 410000);
				stardateToday = stardateToday / 10
				return stardateToday;
			}
		}
	}
</script>

<style lang="less">
	@import '../../less/_variables.less';

	.date-mini {
		height: 35%;
		display: flex;
		justify-content: center;
		flex-wrap: wrap;
		align-items: center;
		padding-bottom: 8%;
		overflow: hidden;

		.date-container {
			color: white;
			font-family: @font-main;
		}

		.date-lg {
			text-align: center;
			font-size: 3em;
			font-weight: 700;
			line-height: 1.8em;
			width: 100%;
		}

		.dates-small {
			display: flex;
			justify-content: space-between;
			width: 100%;
		}

		.date-utc {
			text-align: left;
			font-size: 1.8em;
			line-height: 1.4em;
			padding-right: 1em;
		}

		.date-stardate {
			text-align: right;
			font-size: 1.8em;
			line-height: 1.4em;
		}
	}
</style>


// WEBPACK FOOTER //
// date-mini.vue?d76ac876